export default "__VITE_ASSET__wG7PmukU__"